import React from 'react'
import {BsGithub, BsInstagram, BsLinkedin} from 'react-icons/bs'

const SocialMedia = () => {
  return (
    <div className="app__social">
        <div>
            <a href='https://github.com/GuardianInferno'><BsGithub /></a>
        </div>
        <div>
            <a href='https://www.instagram.com/ha_she_she/'><BsInstagram /></a>
        </div>
        <div>
            <a href='https://www.linkedin.com/in/hashir-abbasi'><BsLinkedin /></a>
        </div>
    </div>
  )
}

export default SocialMedia